export default __webpack_public_path__ + "static/media/institution.bfd5e90b.svg";